// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { monthsToQuarters as fn } from "../monthsToQuarters.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const monthsToQuarters = convertToFP(fn, 1);

// Fallback for modularized imports:
export default monthsToQuarters;
